import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useClubs } from '@/features/clubs/hooks/useClubs';
import ClubCard from './ClubCard';
import { useLoadingContext } from '@/hooks';

export default function ClubList() {
  const { clubs, loading, error, fetchClubs } = useClubs();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoadingContext();

  // Trigger loading when data is loading
  React.useEffect(() => {
    if (loading) {
      startLoading('club-list-data');
    } else {
      stopLoading('club-list-data');
    }
  }, [loading, startLoading, stopLoading]);

  const handleClubClick = (clubHandle: string) => {
    navigate(`/venues/${clubHandle}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        {/* Loading is handled by the global loader */}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-600 mb-4">{error}</p>
        <button
          onClick={fetchClubs}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Try Again
        </button>
      </div>
    );
  }

  if (clubs.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-white mb-4">No venues found</p>
        <button
          onClick={fetchClubs}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Refresh
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-white">All Venues</h2>
        <button
          onClick={fetchClubs}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          Refresh
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {clubs.map((club) => (
          <ClubCard
            key={club.id}
            club={club}
            onClick={() => handleClubClick(club.handle)}
          />
        ))}
      </div>
    </div>
  );
}
